/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import ClockIcon from "../../../Common/Svgs/ClockIcon";
import LocationTickIcon from "../../../Common/Svgs/LocationTickIcon";
import getTimeDifference from "../../../Utils/getTimeDifference";
import TripStartTimeIcon from "../../../Common/Svgs/TripStartTimeIcon";
import TripEndTimeIcon from "../../../Common/Svgs/TripEndTimeIcon";
import { updateTrikes } from "../../../Redux/Slices/trikes.slice";
import TripsIcon from "../../../Common/Svgs/TripsIcon";
import WeightCollectedIcon from "../../../Common/Svgs/WeightCollectedIcon";
import WeightDeliveredIcon from "../../../Common/Svgs/WeightDeliveredIcon";
import { TRIP_STATUS } from "./TripConstants";
import {
  getBatteryText,
  getSpoiltMilkValue,
  getWeightText,
} from "./formatValues";
import SpoiltMilkIcon from "../../../Common/Svgs/SpoiltMilkIcon";
import useRule from "../../../Core/hooks/useRule";
import { TENANT_RULE_VALUE } from "../../Login/constants";
import CustomTooltip from "../../../Core/Components/CustomTooltip";
import UserIcon from "../../../Common/Svgs/UserIcon";
import DateIcon from "../../../Common/Svgs/DateIcon";
import WatchIcon from "../../../Common/Svgs/WatchIcon";

export const KPIData = (currentTrip) => {
  return [
    {
      id: 1,
      icon: <ClockIcon className="text-kpi-background" />,
      title: "Total trip time",
      // value: optimisedRouteTime,
      value:
        getTimeDifference(
          dayjs(currentTrip?.startTime).format("hh:mm"),
          dayjs(currentTrip?.endTime).format("hh:mm"),
        ) || "--",
    },
    {
      id: 2,
      icon: <LocationTickIcon className="text-kpi-background" />,
      title: "No. Of Stops",
      value: currentTrip?.stops?.length,
    },
    {
      id: 3,
      icon: <TripStartTimeIcon />,
      title: "Start Time",
      value:
        currentTrip.startTime !== null
          ? dayjs(currentTrip.startTime).format("hh:mm A")
          : currentTrip?.timeSlot,
    },
    {
      id: 4,
      icon: <TripEndTimeIcon />,
      title: "End Time",
      value:
        currentTrip.endTime !== null
          ? dayjs(currentTrip.endTime).format("hh:mm A")
          : "--",
    },
  ];
};

export const CompletedTripData = (
  tripDetailsKPI,
  overallSummaryForTrip = {},
) => {
  return [
    {
      id: 1,
      icon: <LocationTickIcon className="text-kpi-background" />,
      title: "No. Of Stops",
      value: tripDetailsKPI?.stops || "--",
    },
    {
      id: 2,
      icon: <TripsIcon size={16} className="text-kpi-background" />,
      title: "Total Distance",
      value: tripDetailsKPI?.distance
        ? parseFloat(tripDetailsKPI?.distance).toFixed(2)
        : "--",
      unit: tripDetailsKPI?.distance ? "Km" : "",
    },
    {
      id: 3,
      icon: <ClockIcon className="text-kpi-background" />,
      title: "Trip Duration",
      value: 0,
    },
    {
      id: 4,
      icon: <WeightCollectedIcon className="text-kpi-background" />,
      title: "Total Weight Collected",
      value: parseFloat(tripDetailsKPI.totalCollected)?.toFixed(2) || "--",
      unit: "Kg",
    },
    {
      id: 5,
      icon: <WeightDeliveredIcon className="text-kpi-background" />,
      title: "Total Weight Delivered",
      value: parseFloat(tripDetailsKPI?.totalDelivered)?.toFixed(2) || "--",
      unit: "Kg",
    },
    {
      id: 6,
      icon: <SpoiltMilkIcon className="text-kpi-background" />,
      title: "Total Spoilt Milk",
      value: getSpoiltMilkValue({
        stops: tripDetailsKPI?.spoiltMilkForStops,
        excess: tripDetailsKPI?.excessSpoiltMilk,
      }),
      unit: "L",
    },
    {
      id: 7,
      icon: <UserIcon size={17} className="fill-none stroke-kpi-background" />,
      title: "Driver Name",
      value: overallSummaryForTrip?.driverName ? (
        <CustomTooltip tooltipTitle={overallSummaryForTrip?.driverName || ""}>
          {overallSummaryForTrip?.driverName?.length > 15
            ? `${overallSummaryForTrip.driverName.substring(0, 15)}...}`
            : overallSummaryForTrip.driverName}
        </CustomTooltip>
      ) : (
        "--"
      ),
    },
    {
      id: 8,
      icon: <DateIcon />,
      title: "Date Of Trip",
      value: overallSummaryForTrip?.startTime
        ? dayjs(overallSummaryForTrip?.startTime).format("MMM DD, YYYY")
        : "--",
    },
    {
      id: 9,
      icon: <WatchIcon size={20} className="text-kpi-background" />,
      title: "Start Time",
      value: overallSummaryForTrip?.startTime
        ? dayjs(overallSummaryForTrip?.startTime).format("hh:mm A")
        : "--",
    },
  ];
};

export const UpcomingAndOngoingData = (tripDetailsKPI, currentTrip) => {
  return [
    {
      id: 1,
      icon: <LocationTickIcon className="text-kpi-background" />,
      title: "No. Of Stops",
      value: tripDetailsKPI?.stops || "--",
    },
    {
      id: 2,
      icon: <TripsIcon size={16} className="text-kpi-background" />,
      title: "Total Distance",
      value: tripDetailsKPI?.distance
        ? parseFloat(tripDetailsKPI?.distance).toFixed(2)
        : "--",
      unit: "Km",
    },
    {
      id: 3,
      icon: <ClockIcon className="text-kpi-background" />,
      title: "Trip Duration",
      value: "--",
    },
    {
      id: 4,
      icon: <WeightCollectedIcon className="text-kpi-background" />,
      title: "Total Weight Collected",
      value: getWeightText(tripDetailsKPI.totalCollected, currentTrip.statusId),
      unit:
        currentTrip.statusId === TRIP_STATUS.ONGOING &&
        tripDetailsKPI?.totalCollected
          ? "Kg"
          : null,
    },
    {
      id: 5,
      icon: <WeightDeliveredIcon className="text-kpi-background" />,
      title: "Total Weight Delivered",
      value: getWeightText(tripDetailsKPI.totalDelivered, currentTrip.statusId),
      unit:
        currentTrip.statusId === TRIP_STATUS.ONGOING &&
        tripDetailsKPI?.totalDelivered
          ? "Kg"
          : null,
    },
    {
      id: 6,
      icon: <SpoiltMilkIcon className="text-kpi-background" />,
      title: "Total Spoilt Milk",
      value: "--",
      unit: null,
    },
    {
      id: 7,
      icon: <UserIcon size={17} className="fill-none stroke-kpi-background" />,
      title: "Driver Name",
      value: currentTrip?.driverName ? (
        <CustomTooltip tooltipTitle={currentTrip?.driverName || ""}>
          {currentTrip?.driverName?.length > 15
            ? `${currentTrip.driverName.substring(0, 15)}...}`
            : currentTrip.driverName}
        </CustomTooltip>
      ) : (
        "--"
      ),
    },
    {
      id: 8,
      icon: <DateIcon />,
      title: "Date Of Trip",
      value: currentTrip?.startDate
        ? dayjs(currentTrip?.startDate).format("MMM DD, YYYY")
        : "--",
    },
    {
      id: 9,
      icon: <WatchIcon size={20} className="text-kpi-background" />,
      title: "Start Time",
      value: currentTrip?.startTime
        ? dayjs(currentTrip?.startTime).format("hh:mm A")
        : "--",
    },
  ];
};

export const tripData = (
  currentTrip,
  currentTrike,
  checklistPassed,
  checklistTotal,
) => {
  const dispatch = useDispatch();

  const hasChecklistRule = useRule([TENANT_RULE_VALUE.CHECKLIST]);

  const data = [
    {
      id: 1,
      label: "Driver name",
      value: currentTrip?.driverName,
      redirect: false,
    },
    {
      id: 2,
      label: "Trike no.",
      value: currentTrip?.trikeRegistrationNo || "--",
      redirect: false,
    },
    {
      id: 3,
      label: "Date of trip",
      value: dayjs(currentTrip?.startDate).format("MMM DD YYYY, hh:mm a"),
    },
    {
      id: 5,
      label: "No. of batteries assigned",
      value: currentTrip?.batteries
        ? getBatteryText(currentTrip.batteries)
        : "--",
      redirect: false,
    },
    {
      id: 6,
      label: "Odometer start-end",
      value: `${currentTrike?.odometerStart || "--"} ${
        currentTrike?.odometerEnd || "--"
      }`,
    },
    {
      id: 7,
      label: "Payload",
      value:
        currentTrip.trikeId !== "" && currentTrike?.currentPayload
          ? `${currentTrike?.currentPayload} Kg`
          : "--",
    },
    {
      id: 8,
      label: "Safety Checklist",
      value:
        currentTrip.statusId === TRIP_STATUS.ONGOING &&
        currentTrip.trikeId !== "" ? (
          <div>
            {checklistPassed}/{checklistTotal}
          </div>
        ) : (
          "--"
        ),
      redirect: currentTrip.statusId === TRIP_STATUS.ONGOING,
      onClick: () => {
        if (currentTrip?.statusId === TRIP_STATUS.ONGOING) {
          dispatch(
            updateTrikes({
              key: "checklistModal",
              value: {
                visible: true,
                trike: currentTrike,
                checklist: [],
              },
            }),
          );
        }
      },
    },
  ];

  // do not show checklist item
  return hasChecklistRule ? data : data.filter((d) => d.id !== 8);
};

export const CompletedTripInfoCard = (
  overallSummary,
  currentTrike,
  checklistPassed,
  checklistTotal,
) => {
  const dispatch = useDispatch();

  return [
    {
      id: 1,
      label: "Driver name",
      value: overallSummary?.driverName,
      redirect: false,
    },
    {
      id: 2,
      label: "Trike no.",
      value: overallSummary?.trikeRegistrationNo || "--",
      redirect: false,
    },
    {
      id: 3,
      label: "Date of trip",
      value: dayjs(overallSummary?.startTime).format("MMM DD YYYY, hh:mm a"),
    },
    // {
    //   id: 4,
    //   label: "Total Trip Duration",
    //   value: tripDuration(overallSummary?.startTime, overallSummary?.endTime),
    // },
    {
      id: 5,
      label: "No. of batteries assigned",
      value: overallSummary?.batteries
        ? `${overallSummary.batteries.length} Batteries`
        : "--",
      redirect: false,
    },
    {
      id: 6,
      label: "Odometer start-end",
      value: `${currentTrike?.odometerStart || "--"} ${
        currentTrike?.odometerEnd || "--"
      }`,
    },
    {
      id: 7,
      label: "Payload",
      value:
        overallSummary.trikeId !== "" && currentTrike?.currentPayload
          ? `${currentTrike?.currentPayload} Kg`
          : "--",
    },
    {
      id: 8,
      label: "Safety Checklist",
      value:
        overallSummary.trikeId !== "" ? (
          <div>
            {checklistPassed}/{checklistTotal}
          </div>
        ) : (
          "--"
        ),
      redirect: true,
      onClick: () => {
        dispatch(
          updateTrikes({
            key: "checklistModal",
            value: {
              visible: true,
              checklist: currentTrike.checklist,
              trike: currentTrike,
            },
          }),
        );
      },
    },
  ];
};

export const listForTrikeChange = [
  {
    id: 1,
    reason: "Battery is discharged",
  },
  {
    id: 2,
    reason: "Tire is punctured",
  },
  {
    id: 3,
    reason: "Trike engine is not starting",
  },
  {
    id: 4,
    reason: "Break fail",
  },
  {
    id: 5,
    reason: "Met with an accident",
  },
];
